import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketBlueprints from "components/Market/Blueprints/Blueprints";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketBlueprintsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketBlueprints {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {
    blueprints: marketReducer.getBlueprintsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketBlueprintsContainer);
